import { HeaderProps } from "common/container/types";

export const Header: React.FC<HeaderProps> = ({ title }) => {
  return (
    <>
      {title !== "home" && (
        <div className="md:p-8 mx-4 md:px-4 mt-2">
          <div className=" md:mb-1 sm:mb-10 mt-4 md:mt-0 flex items-center justify-center border-2 border-[#F1AC20]">
            <div className="flex justify-center items-center text-[#2a2a2a] text-2xl md:text-3xl font-bold md:py-8 py-2 2xl:text-[60px]    2xl:w-[80%] sm:w-[50%] p-4 sm:p-5 sm:text-[60px] text-center">
              <p>{title}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
